import { sendRequest } from "../request";
const BASE_URL = '/api/home';

export function getHomeData(user) {
    return sendRequest(`${BASE_URL}/users/${user._id}`, 'GET');
}